@switch (type()) {
  @case ('doughnut') {
    <div class="relative">
      <canvas
        [id]="'chart-' + id()"
        class="relative z-1"
        [width]="width()"
        [height]="height()"></canvas>

      <div
        class="flex flex-col items-center justify-center absolute inset-x-0 w-full"
        [class.inset-y-[50%]]="!isHalfDoughnut()"
        [class.-translate-y-[50%]]="!isHalfDoughnut()"
        [class.inset-y-[25%]]="isHalfDoughnut()"
        [class.translate-y-[25%]]="isHalfDoughnut()">
        @if (title() !== undefined && title() !== null && title() !== '') {
          <p class="text-xs2 text-neutral-700 w-[calc(100%-3rem)] text-center">
            {{ title() }}
          </p>
        }

        @if (value() !== undefined && value() !== null) {
          <p
            class="text-lg font-bold text-neutral-900 w-[calc(100%-3rem)] text-center">
            {{ value() }}
          </p>
        }
      </div>
    </div>
  }

  @case ('line') {
    <canvas
      [id]="'chart-' + id()"
      class="w-full relative z-1"
      [width]="width() || '100%'"
      [height]="height() || '200px'"></canvas>
  }
}
